// extracted by mini-css-extract-plugin
module.exports = {"title":"CdsamAddresses_title__3N0Vh","centered":"CdsamAddresses_centered__1894y","header":"CdsamAddresses_header__lVV2r"};